var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m14.278 10-7.222 6.32V3.68zM12 10 8.556 6.986v6.028z",
    clipRule: "evenodd"
  })));
};
export { SvgChevronRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuMjc3OCAxMC4wMDAyTDcuMDU1NTMgMTYuMzE5Nkw3LjA1NTUzIDMuNjgwNjZMMTQuMjc3OCAxMC4wMDAyWk0xMS45OTk5IDEwLjAwMDJMOC41NTU1MyA2Ljk4NjMyTDguNTU1NTMgMTMuMDE0TDExLjk5OTkgMTAuMDAwMloiIC8+Cjwvc3ZnPgo=";